import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDcameraIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 5H17.54L15.84 2.45C15.65 2.17 15.34 2 15.01 2H9.01C8.68 2 8.36 2.17 8.18 2.45L6.48 5H2C0.9 5 0 5.9 0 7V21C0 22.1 0.9 23 2 23H22C23.1 23 24 22.1 24 21V7C24 5.9 23.1 5 22 5ZM12 19C9.24 19 7 16.76 7 14C7 11.24 9.24 9 12 9C14.76 9 17 11.24 17 14C17 16.76 14.76 19 12 19Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDcameraIcon.displayName = 'TimeDcameraIcon';
